import { SLOT_HOURS } from '@bbbk/schema';
import type { Shift } from './types';

// SLOT_HOURS (a 3-hour AM/PM block) is single-sourced in @bbbk/schema; re-export
// so existing `./stats` importers (pay.ts) keep working.
export { SLOT_HOURS };
// Slots available per day: 4 AM + 4 PM.
export const SLOTS_PER_DAY = 8;

export interface RosterWeekStats {
  helpers: number; // team size
  filled: number; // slots covered this week
  open: number; // slots still uncovered (capacity − filled)
  hours: number; // helper-hours covered this week
  avgDogs: number; // mean dogs-in across the week's days
  peakDogs: number; // busiest day's dogs-in
  peakDay: string | null; // ISO date of the busiest day (null if no dogs)
}

// Supply vs demand for one roster week: how much cover is rostered (helpers,
// filled/open slots, hours) against the load it has to meet (avg/peak dogs in).
// Pure so it unit-tests; `shifts` are assumed already windowed to `dates`.
export function weekRosterStats(
  shifts: Shift[],
  dogsByDate: Map<string, number>,
  dates: string[],
  helpers: number,
): RosterWeekStats {
  const filled = shifts.filter((s) => s.staffId && dates.includes(s.date)).length;
  const capacity = dates.length * SLOTS_PER_DAY;

  let sum = 0;
  let peakDogs = 0;
  let peakDay: string | null = null;
  for (const d of dates) {
    const n = dogsByDate.get(d) ?? 0;
    sum += n;
    if (n > peakDogs) {
      peakDogs = n;
      peakDay = d;
    }
  }

  return {
    helpers,
    filled,
    open: Math.max(0, capacity - filled),
    hours: filled * SLOT_HOURS,
    avgDogs: dates.length ? Math.round(sum / dates.length) : 0,
    peakDogs,
    peakDay,
  };
}
